import { connect } from "react-redux";
import PMSities from "./pmSities";
import { bindActionCreators } from "redux";
import {
  fetchPmSities,
  fetchMonth,
  downloadPMList,
  uploadPmList,
  getPmSitiesFilterDropDown,
} from "services/redux/maintenance/pmSities/action";

const mapStateToProps = (state) => ({
  pmSitiesData: state.pmSitiesReducer.pmSitiesData,
  maintenanceMonth: state.pmSitiesReducer.maintenanceMonth,
  downloadPmList: state.pmSitiesReducer.downloadPmList,
  pmdropdownList: state.pmSitiesReducer.pmdropdownList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchPmSities,
      fetchMonth,
      downloadPMList,
      uploadPmList,
      getPmSitiesFilterDropDown,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PMSities);
